import React from 'react';
import './ProjectsCard.css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

export default function ProjectsCard({image, dataMissing}){
    return(
        
        <Col md={4}>
        <Container className="project-card">
            <Row>
                <Col >
                    <img className="img-project-card no-data" src={image} alt="Project Image"/>
                </Col>
                
            </Row>
            <Row>
                <Col >
                <Row>
                <Col>
                    <h4 className="project-blurb">{dataMissing}</h4>
                </Col>
                
            </Row>
                </Col>
                
            </Row>
            </Container>
        </Col>
        
    )
}